import ImageDimensions from '@/model/ImageDimensions';
import ImageParams from '@/model/ImageParams';
import Watermark from '@/model/Watermark';

import loadImage from './loadImage';

export default {
    async extract(
        image: File,
        expectedSmallHeight: number,
        maxLargeDimensions: ImageDimensions,
        watermark: Watermark,
        signal?: AbortSignal,
    ): Promise<ImageParams> {
        const imageNode = await loadImage(image, signal);
        const imageSize: ImageDimensions = {
            width: imageNode.width,
            height: imageNode.height,
        };
        imageNode.removeAttribute('src');
        const proportion = imageSize.width / imageSize.height;
        const smallThumbSize = {
            width: Math.round(expectedSmallHeight * proportion),
            height: expectedSmallHeight,
            proportion,
        };
        let largeThumbSize: ImageDimensions;
        const maxLargeProportion = maxLargeDimensions.width / maxLargeDimensions.height;
        if (smallThumbSize.proportion >= maxLargeProportion) {
            largeThumbSize = {
                width: Math.round(maxLargeDimensions.width),
                height: Math.round(Math.round(maxLargeDimensions.width / smallThumbSize.proportion)),
            };
        } else {
            largeThumbSize = {
                width: Math.round(maxLargeDimensions.height * smallThumbSize.proportion),
                height: Math.round(Math.round(maxLargeDimensions.height)),
            };
        }

        return {
            imageSize,
            smallThumbSize,
            largeThumbSize,
            file: image,
            contentType: image.type,
            watermark,
            filename: image.name,
        };
    },
};
